import React, { useState } from 'react'
import ImageGallery from 'react-image-gallery';
import "./DetailedProduct.css";
import "react-image-gallery/styles/css/image-gallery.css"
import AddToCart from './cart/AddToCart';
import About from './About/About';

function DetailedProduct({product}) {

    const [selectedValue, setSelectedValue] = useState(product.price[0]);

    return (
        <div className="d-product-container">
            <ImageGallery
                autoPlay={true}
                showPlayButton={false}
                showFullscreenButton={false}
                items={product.images.map(image => {
                    return {
                        original: image.imageUrl,
                        thumbnail: image.imageUrl
                    }
                })}
            />
            <div className="product-name">
                <h2>{product.name}</h2>
            </div>
            <div className="product-details">
                <div className="value">
                    <div>
                        {selectedValue.quantity}
                    </div>
                    <div>
                        ₹ {selectedValue.value}
                    </div>
                </div>
                <div className="value-options">
                    {
                        product.price.map((p, index) => (
                            <div key={index} onClick={() => setSelectedValue(p)} className={`${p == selectedValue? "selected": ""}`}>
                                <p>{p.quantity}</p>
                                <p>₹ {p.value}</p>
                            </div>
                        ))
                    }
                </div>
                <AddToCart id={product.id} value={selectedValue} />
            </div>
            <About className="product-about" />
        </div>
    )
}

export default DetailedProduct
